export const types = {
  OPEN_OPERATION_MODAL: 'modules/quotes/modals/OPEN_OPERATION_MODAL',
  CLOSE_OPERATION_MODAL: 'modules/quotes/modals/CLOSE_OPERATION_MODAL',
  LIVE_PRICING_PREVIEW_REQUEST:
    'modules/quotes/modals/LIVE_PRICING_PREVIEW_REQUEST',
  LIVE_PRICING_PREVIEW_SUCCESS:
    'modules/quotes/modals/LIVE_PRICING_PREVIEW_SUCCESS',
  LIVE_PRICING_PREVIEW_ERROR:
    'modules/quotes/modals/LIVE_PRICING_PREVIEW_ERROR',
  RECEIVE_OVERRIDES: 'modules/quotes/modals/RECEIVE_OVERRIDES',
};

export const operationModal = {
  open: ({ cells, isReadOnly, operation }) => ({
    type: types.OPEN_OPERATION_MODAL,
    payload: {
      cells,
      isReadOnly,
      operation,
    },
  }),
  close: () => ({
    type: types.CLOSE_OPERATION_MODAL,
  }),
  receiveOverrides: ({ nextOverrides }) => ({
    type: types.RECEIVE_OVERRIDES,
    payload: { nextOverrides },
  }),
};

export const livePricingPreview = {
  request: (operationId, newOverrides) => ({
    type: types.LIVE_PRICING_PREVIEW_REQUEST,
    payload: { operationId, overrides: newOverrides },
  }),
  success: (data) => ({
    type: types.LIVE_PRICING_PREVIEW_SUCCESS,
    payload: data,
  }),
  error: () => ({
    type: types.LIVE_PRICING_PREVIEW_ERROR,
  }),
};
